// import React, { useState, useEffect, useMemo } from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import { FaStar, FaQuoteRight, FaQuoteLeft } from 'react-icons/fa';
// import { useLanguage } from './LanguageProvider';

// // Import Swiper and its modules
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Pagination, EffectCoverflow } from 'swiper/modules';

// // Import Swiper CSS
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-coverflow';

// export const ClientOpinion = () => {
//   const { currentLang, isInitialized } = useLanguage();
//   const [isMounted, setIsMounted] = useState(false);

//   useEffect(() => {
//     setIsMounted(true);
//   }, []);

//   const isRtl = currentLang === 'ar';

//   const translations = {
//     en: {
//       badge: "TESTIMONIALS",
//       sectionTitle: "What Our Clients Say",
//       sectionSubtitle: "Don't just take our word for it - hear from some of our satisfied clients who have experienced success with FLYVIA",
//       sarahJohnson: "Sarah Johnson",
//       ceoTechcorp: "CEO, TechCorp Inc.",
//       sarahText: "FLYVIA transformed our digital presence completely. Their team delivered exceptional results that exceeded our expectations. The growth in our online engagement has been phenomenal!",
//       michaelChen: "Michael Chen",
//       marketingDirector: "Marketing Director, InnovateCo",
//       michaelText: "Working with FLYVIA was a game-changer for our business. Their strategic approach and attention to detail helped us achieve 300% growth in just 6 months. Highly recommended!",
//       emilyRodriguez: "Emily Rodriguez",
//       founderStartup: "Founder, StartupXYZ",
//       emilyText: "The team at FLYVIA understood our vision perfectly. They delivered a solution that not only met but exceeded our expectations. Their support has been invaluable.",
//       davidWilson: "David Wilson",
//       operationsManager: "Operations Manager, GlobalTech",
//       davidText: "Professional, efficient, and highly skilled. FLYVIA helped us streamline our processes and improve efficiency by 40%. Their expertise is unmatched.",
//       lisaThompson: "Lisa Thompson",
//       productManager: "Product Manager, NextGen Solutions",
//       lisaText: "Outstanding service and exceptional results! FLYVIA's team worked closely with us to understand our needs and delivered a perfect solution. Truly partners in our success.",
//       robertMartinez: "Robert Martinez",
//       ctoFuturetech: "CTO, FutureTech Enterprises",
//       robertText: "The expertise and dedication of FLYVIA's team are remarkable. They helped us implement cutting-edge solutions that put us ahead of our competitors.",
//     },
//     ar: {
//       badge: "آراء العملاء",
//       sectionTitle: "ماذا يقول عملاؤنا",
//       sectionSubtitle: "لا تأخذ كلمتنا فقط - استمع إلى بعض عملائنا الراضين الذين حققوا النجاح مع FLYVIA",
//       sarahJohnson: "سارة جونسون",
//       ceoTechcorp: "الرئيس التنفيذي، TechCorp Inc.",
//       sarahText: "قامت FLYVIA بتحويل حضورنا الرقمي بالكامل. قدم فريقهم نتائج استثنائية تجاوزت توقعاتنا. كان النمو في مشاركتنا عبر الإنترنت مذهلاً!",
//       michaelChen: "مايكل تشين",
//       marketingDirector: "مدير التسويق، InnovateCo",
//       michaelText: "كان العمل مع FLYVIA نقطة تحول في أعمالنا. ساعدنا منهجهم الاستراتيجي واهتمامهم بالتفاصيل في تحقيق نمو بنسبة 300٪ في 6 أشهر فقط. موصى به بشدة!",
//       emilyRodriguez: "إيميلي رودريجيز",
//       founderStartup: "المؤسس، StartupXYZ",
//       emilyText: "فهم فريق FLYVIA رؤيتنا بشكل مثالي. قدموا حلاً لم يلبِ توقعاتنا فحسب، بل تجاوزها. كان دعمهم لا يقدر بثمن.",
//       davidWilson: "ديفيد ويلسون",
//       operationsManager: "مدير العمليات، GlobalTech",
//       davidText: "محترفون، وكفؤون، ومهرة للغاية. ساعدتنا FLYVIA في تبسيط عملياتنا وتحسين الكفاءة بنسبة 40٪. خبرتهم لا مثيل لها.",
//       lisaThompson: "ليسا تومسون",
//       productManager: "مدير المنتج، NextGen Solutions",
//       lisaText: "خدمة متميزة ونتائج استثنائية! عمل فريق FLYVIA عن كثب معنا لفهم احتياجاتنا وتقديم الحل المثالي. شركاء حقيقيون في نجاحنا.",
//       robertMartinez: "روبرت مارتينيز",
//       ctoFuturetech: "الرئيس التقني، FutureTech Enterprises",
//       robertText: "خبرة وتفاني فريق FLYVIA ملحوظان. ساعدونا في تنفيذ حلول متطورة تضعنا أمام منافسينا.",
//     }
//   };

//   const t = (key) => {
//     const langKey = currentLang || 'en';
//     return translations[langKey]?.[key] || translations.en[key] || key;
//   };

//   const testimonials = useMemo(() => [
//     {
//       id: 1,
//       name: t('sarahJohnson'),
//       position: t('ceoTechcorp'),
//       rating: 5,
//       text: t('sarahText'),
//       avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?auto=format&fit=crop&w=200&q=80"
//     },
//     {
//       id: 2,
//       name: t('michaelChen'),
//       position: t('marketingDirector'),
//       rating: 5,
//       text: t('michaelText'),
//       avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80"
//     },
//     {
//       id: 3,
//       name: t('emilyRodriguez'),
//       position: t('founderStartup'),
//       rating: 4,
//       text: t('emilyText'),
//       avatar: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=200&q=80"
//     },
//     {
//       id: 4,
//       name: t('davidWilson'),
//       position: t('operationsManager'),
//       rating: 5,
//       text: t('davidText'),
//       avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=200&q=80"
//     },
//     {
//       id: 5,
//       name: t('lisaThompson'),
//       position: t('productManager'),
//       rating: 5,
//       text: t('lisaText'),
//       avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80"
//     },
//     {
//       id: 6,
//       name: t('robertMartinez'),
//       position: t('ctoFuturetech'),
//       rating: 4,
//       text: t('robertText'),
//       avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80"
//     }
//   ], [currentLang]);

//   if (!isMounted || !isInitialized) return null;

//   return (
//     <section 
//       id="testimonials"
//       style={{
//         padding: '100px 0',
//         background: '#fcfdfe',
//         position: 'relative',
//         overflow: 'hidden',
//         direction: isRtl ? 'rtl' : 'ltr'
//       }}
//     >
//       {/* Background blobs for visual interest */}
//       <div style={{
//         position: 'absolute',
//         top: '-10%',
//         left: isRtl ? 'auto' : '-5%',
//         right: isRtl ? '-5%' : 'auto',
//         width: '400px',
//         height: '400px',
//         background: 'radial-gradient(circle, rgba(33, 150, 243, 0.08) 0%, rgba(255,255,255,0) 70%)',
//         borderRadius: '50%',
//         zIndex: 0
//       }} />

//       <Container style={{ position: 'relative', zIndex: 1 }}>
//         <Row className="justify-content-center mb-5">
//           <Col lg={8} className="text-center">
//             <span style={{
//               background: 'rgba(33, 150, 243, 0.1)',
//               color: '#2196F3',
//               padding: '8px 20px',
//               borderRadius: '50px',
//               fontSize: '0.85rem',
//               fontWeight: '700',
//               display: 'inline-block',
//               marginBottom: '15px'
//             }}>
//               {t('badge')}
//             </span>
//             <h2 style={{
//               fontSize: '2.5rem',
//               fontWeight: 800,
//               color: '#0f172a',
//               marginBottom: '20px',
//               fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//             }}>
//               {t('sectionTitle')}
//             </h2>
//             <p style={{
//               fontSize: '1.1rem',
//               color: '#64748b',
//               lineHeight: 1.7,
//               maxWidth: '700px',
//               margin: '0 auto',
//               fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//             }}>
//               {t('sectionSubtitle')}
//             </p>
//           </Col>
//         </Row>

//         <Swiper
//           modules={[Autoplay, Pagination, EffectCoverflow]}
//           effect={'coverflow'}
//           grabCursor={true}
//           centeredSlides={true}
//           slidesPerView={'auto'}
//           loop={true}
//           speed={800}
//           coverflowEffect={{
//             rotate: 0,
//             stretch: 0,
//             depth: 100,
//             modifier: 2.5,
//             slideShadows: false,
//           }}
//           autoplay={{ 
//             delay: 4000,
//             disableOnInteraction: false 
//           }}
//           pagination={{ 
//             clickable: true,
//             dynamicBullets: true 
//           }}
//           breakpoints={{
//             320: { slidesPerView: 1 },
//             768: { slidesPerView: 2 },
//             1200: { slidesPerView: 3 }
//           }}
//           style={{ padding: '40px 0 80px' }}
//         >
//           {testimonials.map((item) => (
//             <SwiperSlide key={item.id} style={{ width: '380px', height: 'auto', padding: '10px' }}>
//               {({ isActive }) => (
//                 <div style={{
//                   background: 'white',
//                   borderRadius: '24px',
//                   padding: '40px 30px',
//                   border: '1px solid rgba(241, 245, 249, 1)',
//                   boxShadow: isActive 
//                     ? '0 20px 40px rgba(33, 150, 243, 0.1)' 
//                     : '0 10px 25px rgba(0, 0, 0, 0.03)',
//                   height: '100%',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   transition: 'all 0.4s ease',
//                   opacity: isActive ? 1 : 0.7,
//                   transform: isActive ? 'scale(1.02)' : 'scale(0.95)',
//                   textAlign: isRtl ? 'right' : 'left',
//                   position: 'relative'
//                 }}>
//                   {isRtl ? (
//                     <FaQuoteLeft style={{ fontSize: '2rem', color: '#2196F3', opacity: 0.1, marginBottom: '15px' }} />
//                   ) : (
//                     <FaQuoteRight style={{ fontSize: '2rem', color: '#2196F3', opacity: 0.1, marginBottom: '15px', marginLeft: 'auto' }} />
//                   )}

//                   <div style={{ display: 'flex', gap: '4px', marginBottom: '15px', justifyContent: isRtl ? 'flex-start' : 'flex-start' }}>
//                     {[...Array(5)].map((_, i) => (
//                       <FaStar key={i} color={i < item.rating ? "#ffc107" : "#e2e8f0"} size={16} />
//                     ))}
//                   </div>

//                   <p style={{
//                     fontSize: '1rem',
//                     lineHeight: 1.8,
//                     color: '#334155',
//                     marginBottom: '30px',
//                     flexGrow: 1,
//                     fontStyle: 'italic',
//                     fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//                   }}>
//                     "{item.text}"
//                   </p>

//                   <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '15px',
//                     paddingTop: '20px',
//                     borderTop: '1px solid #f1f5f9'
//                   }}>
//                     <img 
//                       src={item.avatar} 
//                       alt={item.name}
//                       style={{
//                         width: '56px',
//                         height: '56px',
//                         borderRadius: '16px',
//                         objectFit: 'cover'
//                       }}
//                     />
//                     <div>
//                       <h4 style={{ 
//                         margin: 0, 
//                         fontSize: '1.05rem', 
//                         fontWeight: 700, 
//                         color: '#0f172a',
//                         fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//                       }}>{item.name}</h4>
//                       <p style={{ 
//                         margin: 0, 
//                         fontSize: '0.85rem', 
//                         color: '#64748b',
//                         fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//                       }}>{item.position}</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </Container>

//       <style>{`
//         #testimonials .swiper-pagination-bullet {
//           width: 10px;
//           height: 10px;
//           background: #cbd5e1;
//           opacity: 1;
//         }
//         #testimonials .swiper-pagination-bullet-active {
//           width: 25px;
//           border-radius: 5px;
//           background: #2196F3 !important;
//           transition: all 0.3s ease;
//         }
//       `}</style>
//     </section>
//   );
// };


// import React, { useState, useEffect, useMemo } from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import { FaStar, FaQuoteRight, FaQuoteLeft } from 'react-icons/fa';
// import { useLanguage } from './LanguageProvider';

// // Swiper imports
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Pagination, EffectCoverflow } from 'swiper/modules';

// // Swiper CSS
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-coverflow';

// export const ClientOpinion = () => {
//   const { currentLang, isInitialized } = useLanguage();
//   const [isMounted, setIsMounted] = useState(false);

//   useEffect(() => {
//     setIsMounted(true);
//   }, []);

//   const isRtl = currentLang === 'ar';

//   const translations = {
//     en: {
//       badge: "TESTIMONIALS",
//       sectionTitle: "Real Results for Real Partners",
//       sectionSubtitle: "We measure our success by the growth and digital transformation of the brands that trust us.",
//       // Client 1
//       c1Name: "Alexander Wright",
//       c1Pos: "CTO, FinStream Global",
//       c1Text: "The technical architecture FLYVIA implemented for our fintech platform was flawless. We saw a 60% reduction in server latency and a significant boost in user retention within the first quarter.",
//       // Client 2
//       c2Name: "Elena Rodriguez",
//       c2Pos: "Marketing Director, LuxeStay",
//       c2Text: "FLYVIA didn't just build a website; they built a conversion engine. Our direct bookings increased by 140% after the redesign. Their attention to UX and SEO is truly world-class.",
//       // Client 3
//       c3Name: "Dr. James Chen",
//       c3Pos: "Founder, HealthSync AI",
//       c3Text: "Scaling a health-tech startup requires precision. FLYVIA provided the strategic roadmap and development expertise we needed to secure our Series B funding. Exceptional partners.",
//       // Client 4
//       c4Name: "Sarah Jenkins",
//       c4Pos: "Head of Digital, RetailHub",
//       c4Text: "Managing 50,000+ SKUs was a nightmare until FLYVIA optimized our e-commerce infrastructure. Our checkout abandonment rate dropped from 70% to 22% in three months.",
//     },
//     ar: {
//       badge: "آراء العملاء",
//       sectionTitle: "نتائج ملموسة لشركائنا",
//       sectionSubtitle: "نحن نقيس نجاحنا من خلال نمو والتحول الرقمي للعلامات التجارية التي تثق بنا.",
//       // Client 1
//       c1Name: "ألكسندر رايت",
//       c1Pos: "الرئيس التقني، FinStream Global",
//       c1Text: "كانت البنية التقنية التي نفذتها FLYVIA لمنصتنا المالية خالية من العيوب. شهدنا انخفاضًا بنسبة 60% في زمن استجابة الخادم وزيادة كبيرة في احتفاظ المستخدمين.",
//       // Client 2
//       c2Name: "إيلينا رودريغيز",
//       c2Pos: "مديرة التسويق، LuxeStay",
//       c2Text: "لم تقم FLYVIA ببناء موقع إلكتروني فحسب؛ بل قاموا ببناء محرك تحويل. زادت حجوزاتنا المباشرة بنسبة 140% بعد إعادة التصميم. اهتمامهم بتجربة المستخدم استثنائي.",
//       // Client 3
//       c3Name: "د. جيمس تشين",
//       c3Pos: "مؤسس HealthSync AI",
//       c3Text: "يتطلب توسيع شركة ناشئة في مجال التقنية الصحية دقة عالية. قدمت FLYVIA خارطة الطريق الاستراتيجية والخبرة البرمجية التي احتجناها لتأمين التمويل. شركاء رائعون.",
//       // Client 4
//       c4Name: "سارة جينكينز",
//       c4Pos: "رئيسة القسم الرقمي، RetailHub",
//       c4Text: "كانت إدارة أكثر من 50 ألف منتج كابوسًا حتى قامت FLYVIA بتحسين بنيتنا التحتية للتجارة الإلكترونية. انخفض معدل ترك السلة من 70% إلى 22%.",
//     }
//   };

//   const t = (key) => {
//     const langKey = currentLang || 'en';
//     return translations[langKey]?.[key] || translations.en[key] || key;
//   };

//   const testimonials = useMemo(() => [
//     { id: 1, name: t('c1Name'), position: t('c1Pos'), rating: 5, text: t('c1Text'), avatar: "https://i.pravatar.cc/150?u=alex" },
//     { id: 2, name: t('c2Name'), position: t('c2Pos'), rating: 5, text: t('c2Text'), avatar: "https://i.pravatar.cc/150?u=elena" },
//     { id: 3, name: t('c3Name'), position: t('c3Pos'), rating: 5, text: t('c3Text'), avatar: "https://i.pravatar.cc/150?u=james" },
//     { id: 4, name: t('c4Name'), position: t('c4Pos'), rating: 5, text: t('c4Text'), avatar: "https://i.pravatar.cc/150?u=sarah" },
//   ], [currentLang]);

//   if (!isMounted || !isInitialized) return null;

//   return (
//     <section 
//       id="testimonials"
//       style={{
//         padding: '100px 0',
//         background: '#fcfdfe',
//         position: 'relative',
//         overflow: 'hidden',
//       }}
//     >
//       <Container style={{ position: 'relative', zIndex: 1 }}>
//         <Row className="justify-content-center mb-5">
//           <Col lg={8} className={`text-center ${isRtl ? 'rtl' : 'ltr'}`}>
//             <span style={{
//               background: 'rgba(33, 150, 243, 0.1)',
//               color: '#2196F3',
//               padding: '8px 20px',
//               borderRadius: '50px',
//               fontSize: '0.85rem',
//               fontWeight: '700',
//               display: 'inline-block',
//               marginBottom: '15px',
//               fontFamily: isRtl ? "'Cairo', sans-serif" : "inherit"
//             }}>
//               {t('badge')}
//             </span>
//             <h2 style={{
//               fontSize: '2.5rem',
//               fontWeight: 800,
//               color: '#0f172a',
//               marginBottom: '20px',
//               fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//             }}>
//               {t('sectionTitle')}
//             </h2>
//             <p style={{
//               fontSize: '1.1rem',
//               color: '#64748b',
//               lineHeight: 1.7,
//               fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//             }}>
//               {t('sectionSubtitle')}
//             </p>
//           </Col>
//         </Row>

//         <Swiper
//           key={currentLang} // Crucial for re-initializing Swiper logic on language switch
//           dir={isRtl ? 'rtl' : 'ltr'}
//           modules={[Autoplay, Pagination, EffectCoverflow]}
//           effect={'coverflow'}
//           grabCursor={true}
//           centeredSlides={true}
//           slidesPerView={'auto'}
//           loop={true}
//           speed={1000}
//           coverflowEffect={{
//             rotate: 0,
//             stretch: 0,
//             depth: 100,
//             modifier: 2.5,
//             slideShadows: false,
//           }}
//           autoplay={{ 
//             delay: 5000,
//             disableOnInteraction: false 
//           }}
//           pagination={{ 
//             clickable: true,
//             dynamicBullets: true 
//           }}
//           breakpoints={{
//             320: { slidesPerView: 1 },
//             768: { slidesPerView: 2 },
//             1200: { slidesPerView: 3 }
//           }}
//           style={{ padding: '40px 0 80px' }}
//         >
//           {testimonials.map((item) => (
//             <SwiperSlide key={item.id} style={{ width: '400px', height: 'auto', padding: '15px' }}>
//               {({ isActive }) => (
//                 <div style={{
//                   background: 'white',
//                   borderRadius: '28px',
//                   padding: '40px 35px',
//                   border: isActive ? '1px solid #e2e8f0' : '1px solid #f1f5f9',
//                   boxShadow: isActive 
//                     ? '0 25px 50px -12px rgba(0, 0, 0, 0.08)' 
//                     : '0 10px 15px -3px rgba(0, 0, 0, 0.02)',
//                   height: '100%',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
//                   opacity: isActive ? 1 : 0.6,
//                   transform: isActive ? 'scale(1)' : 'scale(0.92)',
//                   textAlign: isRtl ? 'right' : 'left',
//                   position: 'relative'
//                 }}>
//                   {/* Floating Quote Icon */}
//                   <div style={{
//                     position: 'absolute',
//                     top: '30px',
//                     [isRtl ? 'left' : 'right']: '30px',
//                     opacity: 0.1,
//                     fontSize: '2.5rem',
//                     color: '#2196F3'
//                   }}>
//                     {isRtl ? <FaQuoteLeft /> : <FaQuoteRight />}
//                   </div>

//                   <div style={{ display: 'flex', gap: '4px', marginBottom: '20px' }}>
//                     {[...Array(5)].map((_, i) => (
//                       <FaStar key={i} color={i < item.rating ? "#FBBF24" : "#E2E8F0"} size={16} />
//                     ))}
//                   </div>

//                   <p style={{
//                     fontSize: '1.05rem',
//                     lineHeight: 1.8,
//                     color: '#334155',
//                     marginBottom: '35px',
//                     flexGrow: 1,
//                     fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif",
//                     fontWeight: 400
//                   }}>
//                     {item.text}
//                   </p>

//                   <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '15px',
//                     paddingTop: '25px',
//                     borderTop: '1px solid #f8fafc'
//                   }}>
//                     <img 
//                       src={item.avatar} 
//                       alt={item.name}
//                       style={{
//                         width: '60px',
//                         height: '60px',
//                         borderRadius: '18px',
//                         objectFit: 'cover',
//                         border: '2px solid #fff',
//                         boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
//                       }}
//                     />
//                     <div>
//                       <h4 style={{ 
//                         margin: 0, 
//                         fontSize: '1.1rem', 
//                         fontWeight: 700, 
//                         color: '#0f172a',
//                         fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//                       }}>{item.name}</h4>
//                       <p style={{ 
//                         margin: 0, 
//                         fontSize: '0.85rem', 
//                         color: '#64748b',
//                         fontWeight: 500,
//                         fontFamily: isRtl ? "'Cairo', sans-serif" : "'Poppins', sans-serif"
//                       }}>{item.position}</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </Container>

//       <style>{`
//         #testimonials .swiper-pagination-bullet {
//           width: 8px;
//           height: 8px;
//           background: #cbd5e1;
//           opacity: 0.5;
//           transition: all 0.3s ease;
//         }
//         #testimonials .swiper-pagination-bullet-active {
//           width: 28px;
//           border-radius: 4px;
//           background: #2196F3 !important;
//           opacity: 1;
//         }
//         .rtl { direction: rtl; }
//         .ltr { direction: ltr; }
//       `}</style>
//     </section>
//   );
// };


import React, { useState, useEffect, useMemo , useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaStar, FaQuoteRight, FaQuoteLeft } from 'react-icons/fa';
import { useLanguage } from './LanguageProvider';

// Swiper imports
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectCoverflow } from 'swiper/modules';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';

export const ClientOpinion = () => {
  const { currentLang, isInitialized } = useLanguage();
  const [isMounted, setIsMounted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -100px 0px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const isRtl = currentLang === 'ar';

 const translations = {
  en: {
    badge: "CLIENT TESTIMONIALS",
    sectionTitle: "What Our Clients Say",
    sectionSubtitle:
      "Realistic client stories from people who needed legal clarity, visa support, company setup, accounting guidance, and relocation help with FlyVia.",

    c1Name: "Ahmed El-Sayed",
    c1Pos: "Spain Residency Application",
    c1Text:
      "FlyVia helped me understand the right residency path for my case and prepared my documents step by step. What I liked most was that they were honest about what was possible and what needed extra work.",

    c2Name: "Mariam Hassan",
    c2Pos: "Schengen Visa Support",
    c2Text:
      "I had been confused about the Schengen requirements, but the team reviewed my file, fixed missing documents, and guided me before submission. The process felt much clearer and less stressful.",

    c3Name: "Omar Khaled",
    c3Pos: "Company Formation in Spain",
    c3Text:
      "I wanted to open a company in Spain but had no idea where to start. FlyVia explained the legal steps, documents, tax basics, and business setup process in a very practical way.",

    c4Name: "Nadine Mostafa",
    c4Pos: "Legal Document Preparation",
    c4Text:
      "The team helped me prepare and organize my legal documents properly. They followed up on every small detail, which made me feel that my file was handled professionally.",

    c5Name: "Karim Youssef",
    c5Pos: "Accounting & Tax Support",
    c5Text:
      "After setting up my business, I needed help understanding accounting and tax responsibilities. FlyVia made the whole thing simple and helped me avoid mistakes from the beginning.",

    c6Name: "Sara Mahmoud",
    c6Pos: "Family Relocation Planning",
    c6Text:
      "We were planning to move as a family, and FlyVia helped us understand residency, housing, school options, and the first steps after arrival. It felt like having a clear roadmap, not just random advice.",
  },

  ar: {
    badge: "آراء العملاء",
    sectionTitle: "ماذا يقول عملاؤنا",
    sectionSubtitle:
      "تجارب واقعية بصياغة مناسبة لعملاء احتاجوا دعم في الفيزا، الإقامة، تأسيس الشركات، المحاسبة، المستندات القانونية، والانتقال لأوروبا مع FlyVia.",

    c1Name: "أحمد السيد",
    c1Pos: "ملف إقامة في إسبانيا",
    c1Text:
      "FlyVia ساعدوني أفهم أنسب طريق للإقامة حسب حالتي، وجهزوا معايا الأوراق خطوة بخطوة. أكتر حاجة فرقت معايا إن الكلام كان واضح وصريح من البداية.",

    c2Name: "مريم حسن",
    c2Pos: "دعم فيزا شنجن",
    c2Text:
      "كنت متلخبطة في متطلبات فيزا الشنجن، لكن الفريق راجع الملف وحدد النواقص وساعدني أرتب المستندات قبل التقديم. التجربة بقت أوضح وأهدى بكتير.",

    c3Name: "عمر خالد",
    c3Pos: "تأسيس شركة في إسبانيا",
    c3Text:
      "كنت عايز أفتح شركة في إسبانيا ومكنتش عارف أبدأ منين. FlyVia شرحوا لي الخطوات القانونية، الأوراق، الضرائب، وطريقة تأسيس النشاط بشكل عملي جدًا.",

    c4Name: "نادين مصطفى",
    c4Pos: "تجهيز مستندات قانونية",
    c4Text:
      "الفريق ساعدني أجهز المستندات القانونية وأرتبها بطريقة صحيحة. المتابعة كانت دقيقة جدًا، وده خلاني أحس إن الملف متشاف بعين محترفة.",

    c5Name: "كريم يوسف",
    c5Pos: "خدمات محاسبية وضريبية",
    c5Text:
      "بعد تأسيس النشاط كنت محتاج أفهم التزاماتي المحاسبية والضريبية. FlyVia بسطوا لي الموضوع وساعدوني أتجنب أخطاء كان ممكن تكلفني بعدين.",

    c6Name: "سارة محمود",
    c6Pos: "خطة انتقال عائلي",
    c6Text:
      "كنا بنخطط ننتقل كأسرة، وFlyVia ساعدونا نفهم الإقامة، السكن، المدارس، والخطوات الأولى بعد الوصول. حسينا إن معانا خطة واضحة مش مجرد نصائح عامة.",
  },
};

  const t = (key) => {
    const langKey = currentLang || 'en';
    return translations[langKey]?.[key] || translations.en[key] || key;
  };

  const testimonials = useMemo(() => [
    { id: 1, name: t('c1Name'), position: t('c1Pos'), rating: 5, text: t('c1Text'), avatar: "https://i.pravatar.cc/150?u=1" },
    { id: 2, name: t('c2Name'), position: t('c2Pos'), rating: 5, text: t('c2Text'), avatar: "https://i.pravatar.cc/150?u=2" },
    { id: 3, name: t('c3Name'), position: t('c3Pos'), rating: 5, text: t('c3Text'), avatar: "https://i.pravatar.cc/150?u=3" },
    { id: 4, name: t('c4Name'), position: t('c4Pos'), rating: 5, text: t('c4Text'), avatar: "https://i.pravatar.cc/150?u=4" },
    { id: 5, name: t('c5Name'), position: t('c5Pos'), rating: 5, text: t('c5Text'), avatar: "https://i.pravatar.cc/150?u=5" },
    { id: 6, name: t('c6Name'), position: t('c6Pos'), rating: 5, text: t('c6Text'), avatar: "https://i.pravatar.cc/150?u=6" },
  ], [currentLang]);

  if (!isMounted || !isInitialized) return null;

  return (
    <section
      ref={sectionRef}
      id="testimonials"
      style={{
        padding: '100px 0',
        // background: '#fafafa',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <style>{`
        .opinion-label::before {
          content: '';
          display: inline-block;
          width: 24px;
          height: 1px;
          background: var(--primary-color);
          opacity: 0.7;
          vertical-align: middle;
          margin-inline-end: 10px;
        }
        #testimonials .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          background: #cbd5e1;
          opacity: 0.5;
          transition: all 0.3s ease;
        }
        #testimonials .swiper-pagination-bullet-active {
          width: 28px;
          border-radius: 4px;
          background: var(--primary-color) !important;
          opacity: 1;
        }
        .co-bg-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: var(--font-heading);
          font-size: 25vw;
          font-weight: 900;
          color: rgba(0,0,0,0.015);
          pointer-events: none;
          z-index: 0;
          white-space: nowrap;
        }
      `}</style>

      <div className="co-bg-text">OPINIONS</div>

      <Container style={{ position: 'relative', zIndex: 1 }}>
        <Row className="justify-content-center mb-5">
          <Col lg={10} className={`text-center ${isRtl ? 'rtl' : 'ltr'}`}>
            <span 
              className="opinion-label inline-flex items-center mb-6"
              style={{ 
                fontSize: '15px', 
                fontFamily: 'var(--font-secondary)', 
                letterSpacing: '0.4em', 
                textTransform: 'uppercase', 
                color: 'var(--primary-color)', 
                fontWeight: 500 
              }}
            >
              {t('badge')}
            </span>
            <h2
              className={`mb-10 ${isVisible ? 'visible' : ''}`}
              style={{
                fontFamily: 'var(--font-heading)',
                fontSize: 'clamp(48px, 5.5vw, 76px)',
                fontWeight: 300,
                lineHeight: 1.05,
                letterSpacing: '-0.02em',
                color: '#0f172a'
              }}>
              {isRtl ? (
                <>نتائج ملموسة لـ <em style={{ fontStyle: 'italic', color: 'var(--primary-color)' }}>شركائنا</em></>
              ) : (
                <>Real Results for Our <em style={{ fontStyle: 'italic', color: 'var(--primary-color)' }}>Partners</em></>
              )}
            </h2>
            <p style={{
              fontSize: '1.15rem',
              color: '#64748b',
              lineHeight: 1.8,
              maxWidth: '800px',
              margin: '0 auto',
              fontFamily: 'var(--font-secondary)',
              fontWeight: 300
            }}>
              {t('sectionSubtitle')}
            </p>
          </Col>
        </Row>

        <Swiper
          key={currentLang}
          dir={isRtl ? 'rtl' : 'ltr'}
          modules={[Autoplay, Pagination, EffectCoverflow]}
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          loop={true}
          speed={1000}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false,
          }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          pagination={{ clickable: true, dynamicBullets: true }}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 }
          }}
          style={{ padding: '0px 0 80px' }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id} style={{ width: '400px', height: 'auto', padding: '15px' }}>
              {({ isActive }) => (
                <div style={{
                  background: 'white',
                  borderRadius: '28px',
                  padding: '40px 35px',
                  border: '1px solid #f1f5f9',
                  boxShadow: isActive
                    ? '0 25px 50px -12px rgba(0, 0, 0, 0.08)'
                    : '0 10px 15px -3px rgba(0, 0, 0, 0.02)',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                  opacity: isActive ? 1 : 0.6,
                  transform: isActive ? 'scale(1)' : 'scale(0.92)',
                  textAlign: isRtl ? 'right' : 'left',
                  position: 'relative'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '30px',
                    [isRtl ? 'left' : 'right']: '30px',
                    opacity: 0.1,
                    fontSize: '2.5rem',
                    color: '#2196F3'
                  }}>
                    {isRtl ? <FaQuoteLeft /> : <FaQuoteRight />}
                  </div>

                  <div style={{ display: 'flex', gap: '4px', marginBottom: '20px' }}>
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} color={i < item.rating ? "#FBBF24" : "#E2E8F0"} size={16} />
                    ))}
                  </div>

                  <p style={{
                    fontSize: '1.05rem',
                    lineHeight: 1.8,
                    color: '#334155',
                    marginBottom: '35px',
                    flexGrow: 1,
                    fontFamily: 'var(--font-primary)'
                  }}>
                    "{item.text}"
                  </p>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    paddingTop: '25px',
                    borderTop: '1px solid #f8fafc'
                  }}>
                    <div
                      style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '18px',
                        background: 'linear-gradient(135deg, #ae0001 0%, #2c3b5b 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: '1.5rem',
                        fontWeight: 700,
                        fontFamily: 'var(--font-heading)',
                        boxShadow: '0 4px 12px rgba(174,0,1,0.2)'
                      }}
                    >
                      {item.name.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <h4 style={{
                        margin: 0, fontSize: '1.1rem', fontWeight: 700, color: '#0f172a',
                        fontFamily: 'var(--font-heading)'
                      }}>{item.name}</h4>
                    </div>
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>

    </section>
  );
};